module.exports = __webpack_public_path__ + "media/images/emblems/Chancy-coat_of_arms-c7f34924ef294e4e1b4fa713ab8b335b.svg";